module.exports = __webpack_public_path__ + "images/bug_dark_blue_large_db47099daf176fc300a2affc6876590a.png";